import { SLOTS } from './slots.js'

// Sub-categories used to group campaigns/places. Primary links to the edit page.
export default {
  key: 'category',
  label: 'Category',
  icon: 'categories',
  columns: [
    { slot: SLOTS.PRIMARY, field: 'title', link: 'url' },
    // base categories have no page of their own — sub-categories are the managed unit
    { slot: SLOTS.CONTEXT, field: 'category.title', label: 'Base Category', link: false },
    { slot: SLOTS.METADATA, field: 'emoji', label: 'Emoji' }
  ],
  empty: { icon: 'categories', message: 'No categories found.' },
  defaultView: 'table',
  compact: { show: [SLOTS.PRIMARY, SLOTS.CONTEXT] }
}
